import {
    GET_JOB_SITES,
    GET_JOB_SITES_SUCCESS,
    GET_JOB_SITES_FAILURE,
    SET_LANGUAGE,
    INITIALIZE_LANGUAGE,
    SIGNATURE,
    SIGNATURE_SUCCESS,
    SIGNATURE_FAILURE,
    GET_VIDEO,
    GET_VIDEO_SUCCESS,
    GET_VIDEO_FAILURE,
    SIGNATURE_STATUS_SUCCESS,
  } from "./types"
  
  const initialState = {
    jobSiteRequesting: false,
    jobSites: false,
    employeeVideo:null,
    language: "en",
    error: false,
    signature: false,
    signatureRequesting: false,
    video: false,
    videoRequesting: false,
    signatureStatus: undefined,
  }
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case SET_LANGUAGE:
        return {
          ...state,
          language: action.language,
        };
      case GET_JOB_SITES:
        return {
          ...state,
          jobSiteRequesting: true
        }

      case GET_JOB_SITES_SUCCESS:
        return {
          ...state,
          jobSites: action.data,
          jobSiteRequesting: false
        }
  
      case GET_JOB_SITES_FAILURE:
        return {
          ...state,
          jobSiteRequesting: false,
          error: action.error
        }
          case SIGNATURE:
      return {
        ...state,
        signatureRequesting: true
      }

    case SIGNATURE_SUCCESS:
      return {
        ...state,
        signatureRequesting: false,
        signature: action.data
      }

    case SIGNATURE_FAILURE:
      return {
        ...state,
        signatureRequesting: false,
        error: action.error
      }

      case SIGNATURE_STATUS_SUCCESS:
      return {
        ...state,
        signatureStatus: action.data
      }

    case GET_VIDEO:
      return {
        ...state,
        videoRequesting: true
      }

    case GET_VIDEO_SUCCESS:
      return {
        ...state,
        videoRequesting: false,
        video: action.data
      }

    case GET_VIDEO_FAILURE:
      return {
        ...state,
        videoRequesting: false,
        error: action.error
      }
      default:
        return state
    }
  }
  